const initState = {
  waitlistedUsers: [],
  totalPages: null,
  getWaitlistLoader: false,
  waitlistActionLoader: false,
};

const waitlistReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case "GET_WAITLIST_LOADER":
      return {
        ...state,
        getWaitlistLoader: payload,
      };
    case "WAITLIST_ACTION_LOADER":
      return {
        ...state,
        waitlistActionLoader: payload,
      };
    case "GET_WAITLISTED_USERS":
      return {
        ...state,
        waitlistedUsers: payload.users || payload.data || payload || [],
        totalPages: payload.totalPages || 1,
      };
    case "SEARCH_WAITLISTED_USERS":
      return {
        ...state,
        waitlistedUsers: payload.data || payload.users || payload || [],
        totalPages: payload.totalPages || 1,
      };
    case "FILTER_WAITLISTED_USERS":
      return {
        ...state,
        waitlistedUsers: payload.data || payload.users || payload || [],
        totalPages: payload.totalPages || 1,
      };
    case "ACTIVATE_WAITLISTED_USER":
      return {
        ...state,
        waitlistedUsers: state.waitlistedUsers.filter((user) => user.id !== payload),
      };
    case "DELETE_WAITLISTED_USER":
      return {
        ...state,
        waitlistedUsers: state.waitlistedUsers.filter((user) => user.id !== payload),
      };
    default:
      return state;
  }
};

export default waitlistReducer;
